import { Button } from '@eppendorf/vnls-react-components';
import { useTranslation } from 'react-i18next';

export enum EventSeverityFilter {
  All = 'all',
  Error = 'error',
  Alert = 'alert',
  Warning = 'warning',
  Info = 'info',
}

export const EVENT_SEVERITY_FILTERS = Object.values(EventSeverityFilter);

interface SeverityFilterProps {
  selectedSeverity: EventSeverityFilter;
  onSeverityChange: (severity: EventSeverityFilter) => void;
}

export function SeverityFilter({
  selectedSeverity,
  onSeverityChange,
}: SeverityFilterProps) {
  const { t } = useTranslation();

  const severityLabels = new Map<EventSeverityFilter, string>([
    [EventSeverityFilter.All, t('reportHub.filters.all')],
    [EventSeverityFilter.Error, t('reportHub.filters.error')],
    [EventSeverityFilter.Alert, t('reportHub.filters.alert')],
    [EventSeverityFilter.Warning, t('reportHub.filters.warning')],
    [EventSeverityFilter.Info, t('reportHub.filters.info')],
  ]);

  return (
    <div className="flex gap-s m-bottom-m">
      {EVENT_SEVERITY_FILTERS.map((severity) => {
        const isSelected = selectedSeverity === severity;
        return (
          <Button
            key={severity}
            variant={isSelected ? 'primary' : 'outline'}
            onClick={() => onSeverityChange(severity)}
            size="pill"
          >
            <span className="font-size-s">{severityLabels.get(severity)}</span>
          </Button>
        );
      })}
    </div>
  );
}
